import React, { useContext, useState } from 'react';
import './Card.css';
import cardContext from '../../context/cards/cardContext';

const Card = ({ card, onOpenDetails }) => {
  const {handleQuantityChange, quantities} = useContext(cardContext);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);
  
  const quantity = quantities[card.id] || 0;
  
  const handleIncrease = () => {
    handleQuantityChange(card.id, 1);
  };

  const handleDecrease = () => {
    if (quantity > 0) {
      handleQuantityChange(card.id, -1);
    }
  };

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const handleImageError = () => {
    setImageError(true);
    setImageLoaded(true);
  };

  const optimizedImageUrl = card.image;

  const fallbackImage = 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=240&h=240&q=80&fit=crop&auto=format';

  return (
    <div className="card">
      <div className="card-left" onClick={() => onOpenDetails(card)}>
        <h3 className="card-title">{card.name}</h3>
        <p className="card-description">{card.description}</p>
        <p className="card-price">Price: ₹{card.price}</p>
      </div>

      <div className="card-right">
        <div className="card-image-wrapper" onClick={() => onOpenDetails(card)}>
          {!imageLoaded && !imageError && (
            <div className="image-skeleton"></div>
          )}
          <img 
            src={imageError ? fallbackImage : optimizedImageUrl}
            alt={card.name}
            className={`card-image ${imageLoaded ? 'loaded' : ''}`}
            onLoad={handleImageLoad}
            onError={handleImageError}
            loading="lazy"
            decoding="async"
          />
        </div>
        <div className="card-actions">
          <button onClick={handleDecrease}>-</button>
          <span>{quantity}</span>
          <button onClick={handleIncrease}>+</button>
        </div>
      </div>
    </div>
  );
};

export default Card;
